import { connect } from 'react-redux'

import { findCinemaId, findEventId } from '../../global/helpers'
import { setPayment } from '../OrderSummary/reducer'

const mapStateToProps = (state) => {
    const eventid = findEventId(state)
    const cinemaid = findCinemaId(state)

    return {
        isAuth: state?.services?.auth?.isAuthorized,
        error: state?.pages?.yourOrder?.error ?? null,
        basketData: state?.components?.basket?.data ?? null,
        basketLoading: state?.components?.basket?.loading ?? false,
        emptyBasket: !state?.components?.basket?.data?.items_tickets?.length,
        selectedPayment: state?.components?.basket?.data?.selected_payment ?? null,
        snackListToSet: state?.pages?.yourOrder?.snacksList?.snackListToSet,
        eventid,
        cinemaid,
    }
}

const mapDispatchToProps = { setPayment }

const hocYourOrder = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocYourOrder
